import { useRef } from 'react'
import { useComponentSize } from '../hooks'
import Controller from './Controller'
import { ChartsFlowType } from './interfaces'

const Charts = ({ url, type }: ChartsFlowType) => {
  const ref = useRef<HTMLDivElement>(null)
  const size = useComponentSize(ref)
  const { width } = size
  return (
    <div className="wc-rainfall__container relative" ref={ref}>
      <Controller
        width={(width ?? 1000) < 762 ? width ?? 1000 : 762}
        url={url}
        type={type}
      />
    </div>
  )
}

export default Charts
